import lodash from "lodash";
import HTTPRequestHandler from "../../utils/HTTPRequestHandler";
import { toast } from "react-toastify";
import { API_URL } from "../../utils/constants";

const httpRequestHandler = new HTTPRequestHandler();

export function fetchAllData(url, csvName = "CSV_DATA", mapper = null, sorter = null) {
  return function (dispatch) {
    // Detect streaming CSV mode
    if (url.includes("stream_csv")) {
      // Remove any trailing stream_csv params
      const cleanUrl = url
        .replace("&&stream_csv=1", "")
        .replace("?stream_csv=1", "")
        .replace("&stream_csv=1", "");

      // Split base URL and query params
      const [baseUrl, queryString] = cleanUrl.split("?");

      // Build full backend URL correctly
      const fullUrl = `${API_URL.replace(/\/$/, "")}/${baseUrl
        .replace(/^\//, "")
        .replace(/frontend\//, "frontend/")}stream_csv/${
        queryString ? `?${queryString}` : ""
      }`;

      console.log("🔗 Opening stream URL:", fullUrl);

      // Open backend endpoint in new tab → browser handles CSV download
      window.open(fullUrl, "_blank");
      return;
    }

    // Fallback for legacy JSON-based CSV (for smaller data)
    let csvUrl = url + (url.includes("?") ? "&csv=1" : "?csv=1");

    httpRequestHandler
      .get(csvUrl)
      .then((response) => {
        dispatch({
          type: "FETCH_ALL_DATA_SUCCESS",
          payload: response.data,
        });

        let data = response.data;
        if (mapper) data = mapper(data);
        if (sorter) data = sorter(data);

        toCSV(data, csvName);
      })
      .catch((error) => {
        let message = "Error Downloading CSV.";
        if (error.code === "ECONNABORTED") {
          message += " Request Timed Out. Try again later.";
        } else {
          message += " Server Returned Error.";
        }
        toast(message, {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.TOP_CENTER,
        });
        console.error(error);
      });
  };
}

// Converts JSON array → CSV and triggers browser download
const toCSV = (array, csvName) => {
  if (!array || array.length === 0) return;

  const keysArr = lodash.keys(array[0]);
  const keys = keysArr.toString() + "\n";
  let values = "";

  for (let arr of array) {
    let valuesArr = lodash.values(arr);
    for (let i = 0; i < valuesArr.length; i++) {
      if (
        valuesArr[i] &&
        typeof valuesArr[i] === "string" &&
        valuesArr[i].includes(",")
      ) {
        valuesArr[i] = valuesArr[i].replace(/,/g, " | ");
      }
    }
    values += valuesArr.toString() + "\n";
  }

  const csv = keys + values;
  const blobUrl = window.URL.createObjectURL(new Blob([csv]));
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", `${csvName}.csv`);
  document.body.appendChild(link);
  link.click();
};
